import JsonText from "@/components/JsonText";
import Highcharts from "highcharts";
import store from "@/store";

export function injectFakeDataAction() {
  const title = "Set JSON"
  if (this.$store.state.currentUser.enabled_flags.includes('block_and_chart_testing') && !this.$options.widget.actions.some(a => a.title == title)) {
    const dataInjectAction = {
      title,
      handler() {
        this.$buefy.modal.open({
          component: JsonText,
          hasModalCard: true,
          customClass: 'dialog',
          props: {
            existingData: this.httpResponse
          },
          events: {
            save: (value) => {
              this.$options.afterDataLoaded.call(this, JSON.parse(value))
            }
          }
        });
      }
    }
    this.$options.widget.actions.push(dataInjectAction)
  }
  this.emitActions(this.$options.widget.actions)
}

export function configureHighchartsTimeFormat(timeFormat) {
  const is24Hour = timeFormat == '24'
  const dateFormats = {
    dateTimeLabelFormats: {
      millisecond: is24Hour ? '%H:%M:%S.%L' : '%l:%M:%S.%L %p',
      second: is24Hour ? '%H:%M:%S' : '%l:%M:%S %p',
      minute: is24Hour ? '%H:%M' : '%l:%M %p',
      hour: is24Hour ? '%H:%M' : '%l:%M %p',
      day: '%e. %b',
      week: '%e. %b',
      month: '%b \'%y',
      year: '%Y'
    }
  }

  Highcharts.setOptions({
    time: {
      timezone: store.state.currentUser?.timezone
    },
    xAxis: {...dateFormats},
    tooltip: {...dateFormats}
  })
}

export default {
  methods: {
    applyStandardSettings(data) {
      this.chartDescription = data.chart_description
      this.chartTitle = data.title
      this.chartOptions.legend.enabled = data.legend_visible
      this.chartOptions.xAxis.title = { text: data.x_axis_title }
      if (data.y_axis_visible) {
        this.chartOptions.yAxis.visible = true
        this.chartOptions.yAxis.title = { text: data.y_axis_title, margin: 0, x: -10 }
      }

      if (data.scroll_to_right) {
        if (data.series) {
          const longestSerieIndex = data.series.reduce((p, c, i, a) => a[p].data.length > c.data.length ? p : i, 0);
          this.chartOptions.chart.scrollablePlotArea = {
            minWidth: data.series[longestSerieIndex].data.length * 20,
            scrollPositionX: 1
          }
        } else if (data.entries) {
          this.chartOptions.chart.scrollablePlotArea = {
            minWidth: data.entries.length * 40,
            scrollPositionX: 1
          }
        }
      }

      this.chartOptions.legend.padding = 0
      this.chartOptions.legend.y = 10
    }
  },
  mounted() {
    const timeFormat = this.$store.state.currentUser?.time_format
    if (timeFormat) {
      configureHighchartsTimeFormat(timeFormat)
    }

    this.$on('size-changed', isExpanded => {
      this.isExpanded = isExpanded
    })
  },
  data() {
    return {
      chartTitle: null,
      chartDescription: null,
      isExpanded: false
    }
  }
}
